package com.fireavert.info.client.presentation

data class InfoPageViewState(
    val deviceType: String = "",
    val unit: String = "",
    val propertyName: String = "",
    val error: Boolean = false
)
